import Vue from 'vue';

const componentRegistry = {
  registerAll() {
    Vue.component('address-card', () => import('./address-card.vue'));
    Vue.component('mc-count-status-button', () => import('./mc-count-status-button.vue'));
    Vue.component('mc-footer', () => import('./mc-footer.vue'));
    Vue.component('mc-header', () => import('./mc-header.vue'));
    Vue.component('mc-meal-card', () => import('./mc-meal-card.vue'));
    Vue.component('mc-meal-wizard', () => import('./count-wizard/mc-meal-wizard.vue'));
    Vue.component('mc-serve', () => import('./count-wizard/mc-serve.vue'));
    Vue.component('mc-sync', () => import('./mc-sync/mc-sync.vue'));
    Vue.component('mc-waste', () => import('./count-wizard/mc-waste.vue'));
    Vue.component('mc-summary', () => import('./count-wizard/mc-summary.vue'));
    Vue.component('mc-clicker', () => import('./count-wizard/mc-clicker.vue'));
    Vue.component('mc-serving-lines', () => import('./count-wizard/mc-serving-lines.vue'));
    Vue.component('mc-serving-line-summary', () => import('./count-wizard/mc-serving-line-summary.vue'));
    Vue.component('mc-receive', () => import('./count-wizard/mc-receive.vue'));
    Vue.component('mc-tally', () => import('./count-wizard/mc-tally.vue'));
    Vue.component('sponsor-site-info', () => import('./sponsor-site-info.vue'));
    Vue.component('mc-toast', () => import('./mc-toast.vue'));
    Vue.component('mc-msl-prompt', () => import('./mc-msl-prompt.vue'));
    Vue.component('mc-taken-over-prompt', () => import('./mc-taken-over-prompt.vue'));
  }
};

export * from './address-card.vue'
export * from './mc-count-status-button.vue'
export * from './mc-sync/mc-sync.vue'
export * from './mc-footer.vue'
export * from './mc-header.vue'
export * from './count-wizard/mc-meal-wizard.vue'
export * from './count-wizard/mc-serve.vue'
export * from './count-wizard/mc-waste.vue'
export * from './count-wizard/mc-summary.vue'
export * from './count-wizard/mc-clicker.vue'
export * from './count-wizard/mc-serving-lines.vue'
export * from './count-wizard/mc-serving-line-summary.vue'
export * from './count-wizard/mc-receive.vue'
export * from './mc-toast.vue'
export * from './count-wizard/mc-waste.vue'
export * from './count-wizard/mc-tally.vue'
export * from './sponsor-site-info.vue'
export * from './mc-msl-prompt.vue'
export * from './mc-taken-over-prompt.vue'

export default componentRegistry;
